export default __webpack_public_path__ + "static/media/retirement-insurance-benefit.552067a3.png";